$j = jQuery.noConflict();

$j(document).ready(function() {
    $j('#headerButton').on('click', function() {
        $j('html').animate({
            scrollTop: Math.floor($j('.container--4').offset().top)
        }, 1000);
    });

    var carousel = $j('.carousel__content');

    if (carousel.length) {
        carousel.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: true,
            dots: true,
            dotsClass: "slick-dots-ifthenpay",
            arrows: false,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 5000,
            touchThreshold: 4,
            responsive: [
                {
                    breakpoint: 9999,
                    settings: {
                        variableWidth: true,
                        slidesToShow: 4,
                        slidesToScroll: 1,
                        touchThreshold: 16
                    }
                },
                {
                    breakpoint: 1280,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        variableWidth: false,
                        touchThreshold: 8
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        variableWidth: false,
                        touchThreshold: 4
                    }
                }
            ]
        });
    }

    $j('[data-accordion]').moloniAccordion();
});
